$(function () {
	$('a[href*=\\#]:not([href=\\#], .moviePop)').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				var targetOffset = $target.offset().top;
				$('html,body').animate({ scrollTop: targetOffset }, 1000);
				return false;
			}
		}
	});

	$(window).on('scroll', function () {
		var windowHeight = $(window).height(),
			topWindow = $(window).scrollTop();
		$('.fadeIn').each(function () {
			var targetPosition = $(this).offset().top;
			if (topWindow > targetPosition - windowHeight*0.8) {
				$(this).addClass("on");
			}
		});
	}).trigger('scroll');
});

$(window).on('load', function () {
	var localLink = window.location + '';
	if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
		localLink = localLink.slice(localLink.indexOf("#") + 1);
		if ($('#' + localLink).length) {
			setTimeout(function () {
				$('html,body').animate({ scrollTop: $('#' + localLink).offset().top }, 500);
			}, 100);
		}
	}
});